class Details {
  constructor(el, parent) {
    this.selector = {
      content: ".navigation",
      backButton: ".get-back",
      resetButton: ".reset",
    };
    this.overlay = document.querySelector(".overlay");
    this.parent = parent;
    this.el = el;

    if (this.el != null) {
      this.summary = this.el.querySelector("summary");
      this.content = this.el.querySelector(this.selector.content);
      this.backButton = this.el.querySelector(this.selector.backButton);
      this.resetButton = this.el.querySelector(this.selector.resetButton);

      if (this.backButton) {
        this.backButton.addEventListener("click", (e) => this.onClick(e));
      }

      if (this.resetButton) {
        this.resetButton.addEventListener("click", () => this.parent.reset());
      }
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener("click", (e) => this.onClick(e));
    }
  }

  onClick(e) {
    e.preventDefault();

    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.close();
    }
  }

  close() {
    document.documentElement.style.overflow = "hidden";
    if (this.overlay.classList.contains("open")) {
      this.overlay.classList.remove("open");
    }
    const rect = this.content.getBoundingClientRect();

    const endPosition = `${rect.left + rect.width}px`;
    const startPosition = `${rect.left}px`;

    const animateOut = [{ left: startPosition }, { left: endPosition }];

    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.content.animate(animateOut, {
      duration: 300,
      easing: "ease-out",
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
    document.documentElement.style.overflow = "";
  }

  open() {
    document.documentElement.style.overflow = "hidden";

    this.el.open = true;

    if (!this.overlay.classList.contains("open")) {
      this.overlay.classList.add("open");
    }
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const rect = this.content.getBoundingClientRect();
    const startPosition = `${rect.left + rect.width}px`;
    const endPosition = `${rect.left}px`;

    const animateIn = [{ left: startPosition }, { left: endPosition }];
    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.content.animate(animateIn, {
      duration: 300,
      easing: "ease-out",
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}
class CustomeDetails extends HTMLElement {
  constructor() {
    super();
    this.listOfDetails = this.querySelectorAll("details");
    this.listOfCustomDetails = [];
    this.listOfDetails.forEach((item) => {
      const temp = new Details(item, this);
      this.listOfCustomDetails.push(temp);
    });
  }

  open() {
    this.listOfCustomDetails[0].open();
  }

  reset() {
    this.listOfCustomDetails.forEach((item) => {
      if (item.el.open) {
        item.close();
      }
    });
  }
}
customElements.define("custom-details", CustomeDetails);

// Mobile Bottom Navigation,

class MobileBottomNavigation extends HTMLElement {
  constructor() {
    super();
    console.log(this);
  }
}

customElements.define("mobile-bottom-nav", MobileBottomNavigation);
